<template>
    <router-view></router-view>
</template>
<script>
import moment from 'moment'

export default {
    created() {
        this.$store.commit("SET_USER_CHECK_EVENTS")
    }
}
</script>